export default __webpack_public_path__ + "static/media/Q7_2_resized.cc4105fe.jpg";